/**
 * Convert user data retrieved from GraphQL to the old Profile Fields format.
 * This allows us to use components like the UserCard with a simple transform,
 * which could eventually be deleted.
 * @param {Object} data - the graphql data
 * @return {Object} - the profile fields data
 */
const graphqlToUserModel = (data = {}) => {
	const res = {};

	// handle both a Match and User entity. a Match has user as a subfield.
	const user = data.user ? data.user : data;

	res.percentages = {
		match: data.matchPercent,
	};

	res.last_contacts = {
		forward: data.senderMessageTime,
		reverse: data.targetMessageTime,
	};

	res.likes = {
		you_like: !!data.senderLikeTime,
		they_like: !!data.targetLikeTime,
		mutual_like: !!data.senderLikeTime && !!data.targetLikeTime,
		mutual_like_vote: !!data.senderLikeTime && !!data.targetLikeTime,
		via_spotlight: !!data.targetLikeViaSpotlight,
		passed_on: !!data.senderPassed,
		vote: {
			// not sure of the significance of 2 vs 1; just not 0.
			fwd: data.senderLikeTime ? 2 : 0,
			rev: data.targetLikeTime ? 2 : 0,
			fwd_timestamp: data.senderLikeTime,
			rev_timestamp: data.targetLikeTime,
		},
	};

	res.userid = user.id;
	res.username = user.username;

	res.userinfo = {
		username: user.username,
		displayname: user.displayname,
		realname: user.realname,
		age: user.age,
	};

	if (user.location) {
		res.userinfo.location = user.location.summary;

		res.location = {
			locid: user.location.id,
			country_code: user.location.countryCode,
			state_code: user.location.stateCode,
			formatted: {
				short: user.location.summary,
				standard: user.location.summary,
			},
		};
	} else {
		res.location = {};
	}

	res.online = user.isOnline;

	if (user.primaryImage) {
		res.thumbs = [{
			"60x60": user.primaryImage.square60,
			"82x82": user.primaryImage.square82,
			"100x100": user.primaryImage.square100,
			"120x120": user.primaryImage.square120,
			"160x160": user.primaryImage.square160,
			"225x225": user.primaryImage.square225,
			"230x230": user.primaryImage.square230,
			"400x400": user.primaryImage.square400,
			"800x800": user.primaryImage.square800,
		}];
	} else {
		res.thumbs = [];
	}

	return res;
};

export default graphqlToUserModel;



// WEBPACK FOOTER //
// ./src/shared/util/graphqlToUserModel.js